import React, { useState, useEffect } from "react";
import { function_VEN_Reservas_Cabecera_Leer, function_VEN_Reservas_Cabecera_LeerNombresAgasajados } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { CheckBox, TextBox } from "devextreme-react";
import { Column, Button } from "devextreme-react/data-grid";
import { LVGridCarga } from "../../../Basicos/LVGridCarga";
import LV_EEX_Clientes from "../Clientes/LV_EEX_Clientes";
import { LVForm } from "../../../Basicos/LVForm";
import { SimpleItem } from "devextreme-react/form";
import { function_VEN_Reservas_Integrantes_Insertar, function_VEN_Reservas_Integrantes_Eliminar, function_VEN_Reservas_Integrantes_Generar_JSONModificarCheckIn, function_VEN_Reservas_Integrantes_ModificarCheckIn, function_VEN_Reservas_Integrantes_ImpresionCheckIn, function_VEN_Reservas_Integrantes_ModificarAgasajado } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Integrantes";
import { FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import { tr } from "date-fns/locale";
import { function_VEN_Reservas_Pulseras_Leer } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Pulseras";

export const VEN_Reservas_ParticipantesPorItem = (props) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [puedeAgregar, setPuedeAgregar] = useState(false);
  const [agasajado, setAgasajado] = useState(false);
  const [idParticipante, setIdParticipante] = useState(0);
  const [cantidad, setCantidad] = useState(0);
  const [colorSeleccionado, setColorSeleccionado] = useState(null);
  const [colorCorrespondiente, setColorCorrespondiente] = useState(null);
  const [colorBloqueado, setColorBloqueado] = useState(false);
  const [controlIngresado, setControlIngresado] = useState("");
  const [modoParaTodos, setModoParaTodos] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultReserva = await function_VEN_Reservas_Cabecera_Leer(props.Reserva.IdReserva)

      const filteredIntegrantes = resultReserva.data.Integrantes.filter(integrante => integrante.IdItem === props.IdItemSeleccionado);

      const filteredDetalles = resultReserva.data.Detalles.filter(detalle => detalle.IdItem === props.IdItemSeleccionado)
      setCantidad(filteredDetalles[0].CantidadParticipantes)

      const fechaReservaInicio = filteredDetalles[0].FechaReservaInicio;
      const hora = fechaReservaInicio.split(' ')[1].split(':')[0];

      const resultPulseras = await function_VEN_Reservas_Pulseras_Leer(hora)
      setColorCorrespondiente(resultPulseras.data[0].Color)
      if (localStorage.getItem("CodigoCompania") == "302") {
        setColorBloqueado(true)
      }

      setData(filteredIntegrantes);
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  const handlePuedeGuardarChange = (puedeGuardar) => {
    setPuedeAgregar(!puedeGuardar);
  };

  useEffect(() => {
    getData()
  }, []);

  const onClickAgregar = async () => {

    const puedeIngresarParticipante = true

    if (props.IdClienteResponsable < 1) {
      alert('Debe cargar un Responsable válido para la Reserva')
      puedeIngresarParticipante = false;
    }

    if (idParticipante < 1) {
      alert('Debe cargar un Participante válido antes de agregarlo')
      puedeIngresarParticipante = false;
    }

    if (data.length >= cantidad) {
      alert('Ya se ingresó la cantidad máxima de participantes para este ítem')
      return;
    }

    try {
      if (puedeIngresarParticipante) {
        const integrante = {
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
          CodigoPlanta: localStorage.getItem("CodigoPlanta"),
          IdReserva: props.Reserva.IdReserva,
          IdItem: props.IdItemSeleccionado,
          IdCliente: idParticipante,
          Agasajado: agasajado,
          IdClienteResponsable: props.IdClienteResponsable,
        };
        const resultIntegrante = await function_VEN_Reservas_Integrantes_Insertar(integrante)

        if (agasajado){
          const resultAgasajado = await function_VEN_Reservas_Integrantes_ModificarAgasajado(integrante)
        }

        getData()
      }
    } catch (error) {
      alert(error);
    }
  }

  const onClickDelete = async (e) => {
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {

      await function_VEN_Reservas_Integrantes_Eliminar(props.IdItemSeleccionado, Item.IdCliente)

      getData()
    }
  };

  const onClickCheckInGeneral = () => {
    setModoParaTodos(true);
    setColorSeleccionado(colorCorrespondiente);
    setControlIngresado("");
    setMostrarModal(true);
  };

  const onClickImpresionGeneral = async () => {
    for (const participante of data) {
      await function_VEN_Reservas_Integrantes_ImpresionCheckIn(props.Reserva.IdReserva,
        props.IdItemSeleccionado, participante.IdCliente)
    }
  };

  const onClickImpresion = async (e) => {
    const item = { ...e.row.data };

    await function_VEN_Reservas_Integrantes_ImpresionCheckIn(props.Reserva.IdReserva,
      props.IdItemSeleccionado, item.IdCliente)
  };

  const onClickCheckIn = (e) => {
    const item = { ...e.row.data };
    setModoParaTodos(false);
    setIdParticipante(item.IdCliente);
    setColorSeleccionado(item.Color || colorCorrespondiente);
    setControlIngresado(item.Control || "");
    setMostrarModal(true);
  };

  return (
    <div>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div>
          <LVForm
            colCount={4} >
            <SimpleItem colSpan={4}>
              <LV_EEX_Clientes
                onPuedeGuardarChange={handlePuedeGuardarChange}
                setIdParticipante={setIdParticipante} />
            </SimpleItem>
            <SimpleItem>

            </SimpleItem>
            <SimpleItem>
              <CheckBox
                text="AGASAJADO"
                value={agasajado}
                onValueChanged={(e) => setAgasajado(e.value)}
                style={{ marginRight: '20px' }} // Espacio entre CheckBox y el botón
              />
            </SimpleItem>

            <SimpleItem>
              <LVButtonAccion Texto="AGREGAR" Ancho={200} visible={puedeAgregar} onClick={onClickAgregar} />
            </SimpleItem>
            <SimpleItem>

            </SimpleItem>
            <SimpleItem colSpan={4}>
              {data.length > 0 ? (
                <>
                  <LVGridCarga
                    dataSource={data}
                    id="gridContainer"
                    keyExpr="IdItem"
                  >
                    <Column type="buttons" width={100}>
                      <Button name="Eliminar" icon="trash" onClick={onClickDelete} />
                      <Button name="CheckIn" icon="edit" onClick={onClickCheckIn} />
                      <Button name="Impresion" icon="print" onClick={onClickImpresion} />
                    </Column>

                    <Column caption="Código" dataField="IdItem" width="90" alignment="Right" dataType="number" />
                    <Column caption="Agasajado" dataField="Agasajado" width="100" alignment="Center" dataType="boolean" />

                    <Column caption="Participante" alignment="Center" >
                      <Column caption="Código" dataField="IdCliente" width="80" alignment="Right" dataType="number" />
                      <Column caption="Descripción" dataField="Cliente" width="200" alignment="Left" dataType="string" />
                      <Column caption="D.N.I." dataField="DNI" width="90" alignment="Right" dataType="string" />
                      <Column caption="F.Nacimiento" dataField="FechaNacimiento" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
                    </Column>

                    <Column caption="Responsable" alignment="Center" >
                      <Column caption="Código" dataField="IdClienteResponsable" width="80" alignment="Right" dataType="number" />
                      <Column caption="Descripción" dataField="Responsable" width="200" alignment="Left" dataType="string" />
                      <Column caption="D.N.I." dataField="DNIResponsable" width="90" alignment="Right" dataType="string" />
                      <Column caption="F.Nacimiento" dataField="FechaNacimientoResponsable" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
                    </Column>

                    <Column caption="Check In" dataField="FechaCheckIn" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
                    <Column caption="Color" dataField="Color" width="100" alignment="Right" dataType="string" />
                    <Column caption="Control" dataField="Control" width="100" alignment="Right" dataType="string" />
                  </LVGridCarga>
                  <br />
                  <LVButtonAccion Texto="INGRESAR A TODOS" Ancho={300} onClick={onClickCheckInGeneral} />
                  <LVButtonAccion Texto="IMPRESIÓN A TODOS" Ancho={300} onClick={onClickImpresionGeneral} />
                </>
              ) : (
                <div className="card-body text-center">
                  <h5 className="card-title">No hay participantes cargados</h5>
                </div>
              )}
            </SimpleItem>
          </LVForm>


          {mostrarModal && (
            <div style={{
              position: "fixed",
              top: 0, left: 0, right: 0, bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999
            }}>
              <div className='dx-theme-accent-as-background-color' style={{
                padding: "20px",
                borderRadius: "10px", border: '1px solid #26e9ce',
                position: 'fixed',
                top: '50%',
                left: '50%',
                width: "400px",
                transform: 'translate(-50%, -50%)',
                zIndex: 1500 // El maximo es 9999 pero ojo, porque si le pongo mas de 1500, el selector de fechas queda abajo
              }}>
                <h4>INGRESO:</h4>

                <div style={{ marginBottom: 10 }}>
                  <label>COLOR:</label>
                  <TextBox
                    disabled={colorBloqueado}
                    value={colorSeleccionado}
                    onValueChanged={(e) => setColorSeleccionado(e.value)}
                  />
                </div>

                <div style={{ marginBottom: 10 }}>
                  <label>CONTROL:</label>
                  <TextBox
                    value={controlIngresado}
                    onValueChanged={(e) => setControlIngresado(e.value)}
                  />
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                  <button
                    onClick={() => setMostrarModal(false)}
                    style={{
                      color: 'black',
                      backgroundColor: 'inherit',
                      border: '1px solid black',
                      padding: '6px 12px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.4)'
                    }}
                  >
                    CANCELAR
                  </button>
                  <button
                    onClick={async () => {
                      if (!colorSeleccionado) {
                        alert("Debés completar COLOR para continuar.");
                        return;
                      }

                      try {
                        if (modoParaTodos) {
                          for (const participante of data) {
                            const JSON = await function_VEN_Reservas_Integrantes_Generar_JSONModificarCheckIn(
                              props.Reserva.IdReserva,
                              props.IdItemSeleccionado,
                              participante.IdCliente,
                              colorSeleccionado,
                              controlIngresado,
                              await FormateoFechaPara_yyyyMMdd_HHmmss(new Date)
                            );

                            await function_VEN_Reservas_Integrantes_ModificarCheckIn(JSON);
                          }
                          alert("Check In aplicado a todos los participantes.");
                        } else {
                          const JSON = await function_VEN_Reservas_Integrantes_Generar_JSONModificarCheckIn(
                            props.Reserva.IdReserva,
                            props.IdItemSeleccionado,
                            idParticipante,
                            colorSeleccionado,
                            controlIngresado,
                            await FormateoFechaPara_yyyyMMdd_HHmmss(new Date)
                          );

                          await function_VEN_Reservas_Integrantes_ModificarCheckIn(JSON);

                          alert("Check In aplicado al participante.");
                        }

                        getData();
                      } catch (error) {
                        alert("Error al guardar: " + error.message);
                      } finally {
                        setMostrarModal(false);
                      }
                    }}
                    style={{
                      color: 'black',
                      border: '1px solid black',
                      backgroundColor: 'inherit',
                      padding: '6px 12px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.4)'
                    }}
                  >
                    GUARDAR
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
